<template>
  <section>
    <div class="role">
      <div class="roleRight" style="border-left: 0">
        <div class="roleRight_Top">
          <el-input
              size="mini"
              clearable
              v-model="search.keyword"
              clas="input_search"
              placeholder="搜索关键字"
              @keyup.enter.native="SearchRoleList"
          ></el-input>
          <el-select size="mini" v-model="search.regionId" clearable placeholder="请选择板块">
            <el-option v-for="(item,index) in plateList" :value="item.id" :key="index" :label="item.name"></el-option>
          </el-select>
          <el-select size="mini" v-model="search.status" clearable placeholder="请选择">
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
          <el-button size="mini" type="primary" @click="SearchRoleList"
          >查询
          </el-button
          >
          <el-button
              size="mini"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              :data="tableData"
              size="medium"
              border
              style="width: 100%"
              row-key="roleId"
              v-loading="loading"
          >
            <el-table-column
                fixed
                label="序号"
                prop="roleId"
                type="index"
                width="80"
            >
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" min-width="150">
            </el-table-column>
            <el-table-column prop="code" label="标识" min-width="180">
            </el-table-column>
            <el-table-column prop="languageName" label="使用语言" min-width="180">
            </el-table-column>
            <el-table-column prop="currencyName" label="使用货币" min-width="180">
            </el-table-column>
            <el-table-column prop="regionName" label="所属板块" min-width="180">
            </el-table-column>
            <el-table-column prop="score" label="分数" min-width="180">
            </el-table-column>
            <el-table-column prop="rate" label="图片" min-width="180">
              <template slot-scope="scope">
                <el-image :src="scope.row.flag" style="max-width: 50px;max-height: 50px"></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="150">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.status"
                    :active-value="1"
                    :inactive-value="0"
                    @change="handleStatusSwitch(scope.row.id)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="默认" width="150">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.isDefault"
                    :active-value="1"
                    :inactive-value="0"
                    @change="handleSwitch(scope.row.id)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="sort" label="排序" min-width="80">
              <template slot-scope="scope">
                <el-input
                    size="mini"
                    type="text"
                    placeholder="输入参与数"
                    v-model="scope.row.sort"
                    @blur="changOrdered(scope.row.sort, scope.row.id)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" min-width="240">
              <template slot-scope="scope">
                <el-button
                    @click="handleClick('editPay', scope.row)"
                    plain
                    type="warning"
                    size="small"
                >支付
                </el-button>
                <el-button
                    @click="handleClick('edit', scope.row)"
                    plain
                    size="small"
                >修改
                </el-button>
                <el-button
                    type="primary"
                    plain
                    size="small"
                    @click="del(scope.row)"
                >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="public-pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pages.pageNo"
                :page-sizes="[10, 50, 100, 200, 400]"
                :page-size="pages.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-drawer
        title="新增/编辑 国家/地区"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        size="45%"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="100px"
        >
          <el-tabs type="card" v-model="languageCode" @tab-click="handleTabClick">
            <el-tab-pane v-for="(item,index) in languageList" :label="item.name" :name="item.code"
                         :key="index"></el-tab-pane>
          </el-tabs>
          
          <!-- 修改表单项布局，使用栅格系统实现每行两列 -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item class="item" label="图片">
                <upLoadImg
                    :keyWord="'flag'"
                    :params="params"
                    v-if="flag"
                ></upLoadImg>
              </el-form-item>
            </el-col>
            
            <el-col :span="11">
              <el-form-item
                  label="使用货币："
                  prop="region_id"
              >
                <el-select style="width: 100%" v-model="params.currency_id" clearable placeholder="请选择货币">
                  <el-option v-for="(item,index) in currencyList" :value="item.id" :key="index"
                            :label="item.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            
            <el-col :span="11">
              <el-form-item
                  label="使用语言："
                  prop="region_id"
              >
                <el-select style="width: 100%" v-model="params.language_id" clearable placeholder="请选择语言">
                  <el-option v-for="(item,index) in languageList" :value="item.id" :key="index"
                            :label="item.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            
            <el-col :span="11">
              <el-form-item
                  label="所属板块："
                  prop="region_id"
              >
                <el-select style="width: 100%" v-model="params.region_id" clearable placeholder="请选择板块">
                  <el-option v-for="(item,index) in plateList" :value="item.id" :key="index" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            
            <el-col :span="12">
              <el-form-item
                  label="名称："
                  prop="name"
              >
                <el-input
                    clearable
                    placeholder="请填写名称"
                    v-model="params.name"
                ></el-input>
              </el-form-item>
            </el-col>
            
            <el-col :span="11">
              <el-form-item
                  label="编码："
                  prop="code"
              >
                <el-input
                    clearable
                    placeholder="请填写编码"
                    v-model="params.code"
                ></el-input>
              </el-form-item>
            </el-col>
            
            <el-col :span="12">
              <el-form-item
                  label="分数："
                  prop="score"
              >
                <el-input
                    clearable
                    placeholder="请填写分数"
                    v-model="params.score"
                ></el-input>
              </el-form-item>
            </el-col>
            
            <el-col :span="11">
              <el-form-item
                  label="排序："
                  prop="sort"
              >
                <el-input
                    clearable
                    placeholder="请填写排序"
                    v-model="params.sort"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-form-item
              label="商户类型："
              prop="mchTypes"
          >
            <el-table
                :data="mchTypesTableData"
                  height="258"
                border
                style="width: 95%">
              <el-table-column
                  prop="paymentCode"
                  label="支付代码"
                  width="180">
              </el-table-column>
              <el-table-column
                  label="商户类型">
                <template slot-scope="scope">
                  <div v-if="scope.row.paymentCode === 'PP'">
                    <el-checkbox 
                        v-for="type in paypalMchTypes" 
                        :key="type" 
                        v-model="scope.row.mchTypes" 
                        :label="type">
                    </el-checkbox>
                  </div>
                  <div v-else>
                    <el-checkbox 
                        v-for="type in commonMchTypes" 
                        :key="type" 
                        v-model="scope.row.mchTypes" 
                        :label="type">
                    </el-checkbox>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
        <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
      </div>
    </el-drawer>
    <!-- 编辑支付方式 -->
    <el-dialog
        title="关联支付"
        :visible.sync="paymentVistab"
        :close-on-click-modal="false"
        width="900px"
        class="public-dialog">
      <div class="public-dialog-form" style="padding-bottom: 20px;">
        <!-- 支付 -->
        <div class="payment_box_infos">
          <div class="button_item">
            <span>仅使用PayPal：</span>
            <el-switch
                v-model="paypalStatus"
                :active-value="true"
                :inactive-value="false"
                @change="changePaypalSwitch"
            >
            </el-switch>
          </div>
          <el-button size="mini" type="primary" @click="addMerchant">添加商户</el-button>
        </div>
        
        <p>国家/地区名称: {{ currentCountry.name || ''}}</p>
        <div style="display: flex;align-items: center;">
          <el-tabs style="margin-top: 20px;" v-model="payCode" type="card" @tab-click="activePayEventNav">
            <el-tab-pane v-for="item in payTypeList" :key="item.targetCode" :label="item.targetName" :name="item.targetCode"></el-tab-pane>
          </el-tabs>
          <div class="addpay" @click="paytypeDialog = true">＋</div>
        </div>
         <el-table
            ref="multipleTable"
            size="medium"
            :data="payMentListInfo"
            border
            style="width: 100%"
            row-key="menuId"
            v-loading="loading"
        >
          <el-table-column type="index" label="序号" width="50" align="center">
          </el-table-column>
          <el-table-column prop="targetName" label="商户名称" align="center">
          </el-table-column>
          <el-table-column prop="targetId" label="商户ID"  align="center">
          </el-table-column>
          <el-table-column prop="sort"  label="排序" align="center">
            <!-- <template slot-scope="scope">
              <input class="sortInput" type="text" v-model="scope.row.sort">
            </template> -->
          </el-table-column>
          <el-table-column prop="code" label="状态" width="80" align="center">
            <template slot-scope="scope">
              <el-switch
                  v-model="scope.row.status"
                  :active-value="1"
                  :inactive-value="0"
                  @change="changePaymentSwitch(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                  @click="editMch(scope.row)"
                  type="primary"
                  size="small">编辑
              </el-button>
              <el-button
                @click="delMch(scope.row)"
                  slot="reference"  
                  type="danger"
                  size="small">删除
              </el-button>
             
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer">
        <div class="footerBtns">
          <el-button size="mini" type="primary" @click="paymentVistab = false">完成</el-button>
          <!-- <el-button size="mini" type="primary" @click="saveMchlist" >提 交</el-button> -->
        </div>
      </span>
    </el-dialog>
    <el-dialog 
        title="支付方式"
        :visible.sync="paytypeDialog"
        :close-on-click-modal="false"
        @close="cancelPaytypeDialog"
        width="600px"
        class="public-dialog">
        <div class="addPayBtn">
          <el-button size="mini" type="primary" @click="getAllPays">添 加</el-button>
        </div>
        <el-table
            size="medium"
            :data="payTypeList"
            border
            style="width: 100%"
            row-key="menuId"
            v-loading="loading"
        >
        <el-table-column type="index" label="序号" width="50" align="center">
        </el-table-column>
        <el-table-column prop="paymentName" label="名称" align="center">
        </el-table-column>
          <el-table-column prop="paymentType" label="类型" align="center">
          </el-table-column>
        <el-table-column prop="icon" label="icon" align="center">
          <template slot-scope="scope">
            <img class="tableicon" :src="scope.row.icon" alt="">
          </template>
        </el-table-column>
        <el-table-column  label="排序" align="center">
          <template slot-scope="scope">
            <input class="sortInput" type="text" v-model="scope.row.sort">
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
                @click="delpayType(scope.$index)"
                type="danger"
                size="small">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <div class="footerBtns">
          <el-button size="mini" @click="cancelPaytypeDialog">取 消</el-button>
          <el-button size="mini" type="primary" @click="savePaymentInfo" >提 交</el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
        title="支付类型列表"
        :visible.sync="paytypeListDialog"
        :close-on-click-modal="false"
        width="600px"
        class="public-dialog"
        >
        <el-table
          :data="paytypeListData.filter(data => !searchKey || data.name.toLowerCase().includes(searchKey.toLowerCase()))"
          style="width: 100%"
          height="500px"
          ref="payMultipleTable"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column type="index" label="序号" width="50" fixed align="center">
          </el-table-column>
          <el-table-column
            label="Name"
            prop="name">
          </el-table-column>
          <el-table-column prop="paymentType" label="类型" align="center">
          </el-table-column>
          <el-table-column
            label="备注"
            prop="descr">
          </el-table-column>
          <el-table-column
            align="right">
            <template slot="header">
              <el-input
                v-model="searchKey"
                size="mini"
                placeholder="输入关键字搜索"/>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer">
        <div class="footerBtns">
          <el-button size="mini" @click="paytypeListDialog = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="confirmPayList" >提 交</el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="添加商户"
      :visible.sync="merchantDialog"
      :close-on-click-modal="false"
      @close="closeMerchantDialog"
      width="700px"
      class="public-dialog"
      >
      <div class="merchant">
        <div class="merchant__input">
          <div>
            <div class="remark">
              <div class="label">支付商户</div>
              <el-select size="mini" clearable placeholder="请选择支付商户" v-model="merchantInfo.targetId">
                <el-option v-for="mch in mchList" :key="mch.mchId" :value="mch.paymentMchId" :label="mch.mchName"></el-option>
              </el-select>
            </div>
            <div class="remark">
              <div class="label">备注</div>
              <el-input v-model="merchantInfo.remark" class="remark__input" size="mini" placeholder="请输入备注"></el-input>
            </div>
            <div class="remark">
              <div class="label">排序</div>
              <el-input v-model="merchantInfo.sort" class="remark__input" size="mini" placeholder="请输入排序"></el-input>
            </div>
          </div>
          <div class="up-btn merchant__upload"
              @click="getPolicy">
            <i class="el-icon-plus"></i>
            大图标
          </div>
          <input
              type="file"
              ref="file"
              @change="getFile"
              accept="image/png,image/jpg"
          />
          <div class="up-btn merchant__upload"
              @click="getPolicy">
            <i class="el-icon-plus"></i>
            小图标
          </div>
        </div>
        <el-tabs style="margin-top: 20px;" type="card" v-model="languageCode" @tab-click="merchantHandleTabClick">
          <el-tab-pane v-for="(item,index) in languageList" :label="item.name" :name="item.code"
                        :key="index"></el-tab-pane>
        </el-tabs>
        <div class="remark">
          <div class="label">框内名称</div>
          <el-input v-model="merchantInfo.boxName" size="mini" placeholder="请输入框内名称"></el-input>
        </div>
        <div class="remark">
          <div class="label">按钮名称</div>
          <el-input v-model="merchantInfo.buttonName" size="mini" placeholder="请输入按钮名称"></el-input>
        </div>
      </div>
      <span slot="footer">
        <div class="footerBtns">
          <el-button size="mini" @click="closeMerchantDialog">取 消</el-button>
          <el-button size="mini" type="primary" @click="saveMerchantInfo" >提 交</el-button>
        </div>
      </span>
    </el-dialog>
  </section>
</template>
<script>

import upLoadImg from "@views/international/components/upLoadImg";
import uploadCommonImg from "@comp/uploadCommonImg";
import {ossUpload} from "@utils/filters/upload";

export default {
  components: {upLoadImg, uploadCommonImg},
  data() {
    return {
      loading: false,
      search: {},
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        name: [{required: true, message: "请填写名称", trigger: "blur"}],
        code: [{required: true, message: "请填写标识", trigger: "blur"}],
        sourceLanguage: [{required: true, message: "请填写源语言", trigger: "blur"}],
      }, //表单验证提示
      tableData: [], //二级--角色列表，
      dialogVisible: false,
      changeTimer: false,
      pages: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      plateList: [],
      languageList: [],
      currencyList: [],
      flag: false,
      languageCode: "",
      paymentVistab:false,
      paypalStatus:false,
      currentCountry:{},
      payCode:'',
      payTypeList:[],
      payMentListInfo:[],   //当前支付方式下的商户列表
      paytypeDialog:false,  //支付方式排序，删除的弹窗
      paytypeListDialog:false, //新增支付方式弹窗
      paytypeListData:[], //所有支付方式列表
      searchKey:'',
      multipleSelection:[], //勾选的支付方式列表
      merchantDialog:false,  //添加商户弹窗
      merchantInfo:{
        targetCode:null,  //支付方式code
        targetId:'',     //商户ID
        remark:'',
        sort:'',
        boxName:'', // 框内名称
        buttonName: '', //按钮名称   
      },  //提交的商户信息
      curLanguage:'',
      mchList:[], //当前支付方式下可选择的商户
      srcList: [],
      isMoer: true,
      visible:false,
      commonMchTypes: ["STRIPE", "AIRWALLEX","NMI_HMS","NMI_PAYMENT_CLOUD"],
      paypalMchTypes: ["PAYPAL"],
      mchTypesTableData: [
        { paymentCode: 'AP', mchTypes: [] },
        { paymentCode: 'GP', mchTypes: [] },
        { paymentCode: 'PP', mchTypes: [] },
        { paymentCode: 'CC', mchTypes: [] }
      ]
    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.flag = false;
      }
    },
  },
  created() {
    this.getCountryList();
    this.getPlateList();
    this.getLanguageList();
    this.getCurrencyList()
  },
  methods: {
    //币种
    async getCurrencyList() {
      this.loading = true;
      //角色列表
      const {data: res} = await this.$post(
          `/currency/page`, {pageSize: 999, pageNo: 1},
      );
      this.loading = false;
      this.currencyList = res.data;
    },
    handleTabClick() {
      this.flag = false;
      if (this.params.id) {
        this.getCountryInfo()
      } else {
        this.$nextTick(() => {
          this.flag = true;
        });
      }
    },
    //切换商户状态
    async changePaymentSwitch(row){
      const { data: res } = await this.$get(
        `/country/payment/change/status/${row.id}/`
      )
      if (res.result == 200) {
        this.$message.success(res.message)
      }
    },
    //设置仅使用paypal
    async changePaypalSwitch(){
      !this.paypalStatus
      const {data: res } = await this.$get(
        '/country/payment/only/paypal/change',
        {
          params:{
            countryCode: this.currentCountry.code,
          }
        }
      )
      if (res.result === 200) {
        this.$message.success(res.message)
      }
    },
    //切换支付方式
    activePayEventNav(){
      console.log("activePay",this.payCode);
      this.getMerchantByPaycode()
    },
    //获取板块列表
    async getPlateList() {
      this.loading = true;
      //角色列表
      const {data: res} = await this.$post(
          `/region/list`, {},
      );
      this.loading = false;
      this.plateList = res.data
    },
    //获取语言列表
    async getLanguageList() {
      this.loading = true;
      //角色列表
      const {data: res} = await this.$post(
          `/language/list`, {adminStatus: 1},
      );
      this.loading = false;
      this.languageList = res.data;
      this.languageCode = res.data[0].code
    },
    SearchRoleList() {
      this.getCountryList()
    },
    async getCountryList() {
      this.loading = true;
      //角色列表
      const {data: res} = await this.$post(
          `/country/page`, {...this.search, ...this.pages},
      );
      this.loading = false;
      this.tableData = res.data;
      this.total = res.page.count;
    },
    //switch状态改变 --接口 修改角色状态
    handleStatusSwitch(id) {
      this.$get(`/country/state/change/${id}/`).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
          this.getCountryList()
        }
      });
    },
    //设置排序
    async changOrdered(num, data) {
      const {data: resData} = await this.$get(
          `/country/sort/edit/${data}/`, {
            params: {
              sort: num
            }
          },
          {
            headers: {
              isLoading: true,
            },
          }
      );
      this.$message.success('操作成功')
      this.getCountryList()
    },
    //switch状态改变 --接口 修改角色状态
    handleSwitch(id) {
      this.$get(`/country/state/switch/${id}/`).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
          this.getCountryList()
        }
      });
    },
    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      if (type == "addNext") {
        //编辑
        this.dialogVisible = true;
        this.params = {};
        this.$nextTick(() => {
          this.flag = true;
        });
      } else if (type == "edit") {
        //修改  change
        this.dialogVisible = true;
        this.params = JSON.parse(JSON.stringify(row));
        this.getCountryInfo()
      } else if (type == "editPay") {
        // this.paymentVistab = true
        this.paytypeDialog = true
        this.currentCountry = row
        this.getPaymentInfoByCountry()
      }
    },
    //获取当前国家支付信息
    async getPaymentInfoByCountry(){
      // this.checkPaypalStatus()
      this.payTypeList = []
      const { data: res } = await this.$get(
        '/country/payment/method/list',
        { 
          params: {
            countryCode: this.currentCountry.code
          }
        }
      )
      this.payTypeList = res.data || []
      if (this.payTypeList.length > 0) {
        this.payCode = this.payTypeList[0].targetCode
        // this.getMerchantByPaycode()
      }
    },
    //查看当前国家仅paypal支付状态
    async checkPaypalStatus(){
      const { data: res } = await this.$get(
        '/country/payment/only/paypal/status',
        {
          params: {
            countryCode: this.currentCountry.code,
          }
        }
      )
      this.paypalStatus = res.data
    },
    //获取当前支付方式已绑定的商户列表
    async getMerchantByPaycode(){
      const { data: res } = await this.$get(
        '/country/payment/list',
        { 
          params: {
            countryCode: this.currentCountry.code,
            targetType: 'merchants',
            targetCode: this.payCode
          }
        }
      )
      this.payMentListInfo = res.data || []
    },
    //获取当前支付方式所有的商户列表
    async getALLMerchantByPaycode(){
      const { data: res } = await this.$get(
        '/payment/mch/list',
        {
          params:{
            paymentType: this.payCode
          }
        }
      )
      this.mchList = res.data
    },
    addMerchant(){
      this.merchantInfo = {
        targetCode:null,  //支付方式code
        targetId:'',     //商户ID
        sort:'',
        remark:'',
        boxName:'', // 框内名称
        buttonName: '', //按钮名称   
      }
      this.merchantDialog = true
      this.getALLMerchantByPaycode()
    },
    editMch(row){
      this.merchantInfo = row
      this.merchantDialog = true
      this.languageCode = this.languageList[0].code
      this.getALLMerchantByPaycode()
    },
    async delMch(row){
      this.$confirm("确认删除该商户吗?", "提示", {
        type: "warning",
      }).then(async () => {
        const { data: res } = await this.$get(
          `/country/payment/remove/${row.id}/`
        )
        if (res.result == 200) {
          this.$message.success(res.message)
          this.getMerchantByPaycode()
        }
      });
    },
    //保存商户列表
    async saveMchlist(){
      const { data: res } = await this.$post(
        '/country/payment/submit',
        this.payMentListInfo
      ) 
      if (res.result == 200) {
        this.$message.success(res.message)
        this.paymentVistab = false
      }
    },
    //查询所有支付方式
    async getAllPays(){
      this.paytypeListDialog = true
      const { data: res } = await this.$get(
        'payment/type/list',
        {
          params: { pageNo:1,pageSize:100,status:1 }
        }
      )
      let tempArr = res.data
      if (this.payTypeList.length > 0) {
        const result = tempArr.filter(itemA => !this.payTypeList.some(itemB => itemB.paymentType === itemA.paymentType));
        this.paytypeListData = result
      } else {
        this.paytypeListData = tempArr
      }
    },
    //删除已选择的支付方式
    delpayType(index){
      this.payTypeList.splice(index, 1)
    },
    //选择支付方式
    handleSelectionChange(val){
      this.multipleSelection = val;
      this.multipleSelection.forEach(el => {
        el.paymentName = el.name
      })
    },
    //确认勾选的支付方式
    confirmPayList(){
      this.payTypeList = this.payTypeList.concat(this.multipleSelection)
      this.paytypeListDialog = false
    },
    //取消保存
    cancelPaytypeDialog(){
      this.paytypeDialog = false
      this.getPaymentInfoByCountry()
    },
    //保存支付方式
    async savePaymentInfo(){
      this.payTypeList.forEach(el => {
        el.countryCode = this.currentCountry.code
      })
      const methods = this.payTypeList.map(el => { 
        return { paymentTypeId: el.paymentTypeId, sort: el.sort }
      })
      const { data } = await this.$post(
        '/country/payment/method/bind',
        {
          "countryCode": this.currentCountry.code,
          "paymentMethods": methods
        }
      )
      if (data.result == 200) {
        this.$message.success(data.message)
        this.cancelPaytypeDialog()
      }
    },
    //选择文件
    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile() {
      const that = this;
      const {data: resData} = await this.$get("aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one", //'more','one'
          this.srcList
      );
      this.isMoer = false;
      this.srcList = addRoutes;
      console.log("this.srcList",this.srcList);
    },
    //新增商户时切换语言
    async merchantHandleTabClick(){
      if (!this.merchantInfo.id) {
        return
      }
      const { data: res } = await this.$get(
        `country/payment/get/${this.merchantInfo.id}/`,{
          headers: {
            isLoading: true,
            'Language-Code': this.languageCode
          },
        }
      )
      this.merchantInfo = res.data
    },
    closeMerchantDialog(){
      this.merchantDialog = false
      this.getPaymentInfoByCountry()
    },
    //保存商户信息
    async saveMerchantInfo(){
      let targetName = ''
      this.mchList.forEach(el => {
        if (el.paymentMchId === this.merchantInfo.targetId) {
          targetName = el.mchName
        }
      })
      let params = Object.assign(
        this.merchantInfo,
        {
          targetType:'merchants',
          targetCode:this.payCode,
          countryCode: this.currentCountry.code,
          targetName
        }
      )
      const { data: res } = await this.$post(
        'country/payment/save', params,
        {
          headers: {
              isLoading: true,
              'Language-Code': this.languageCode
            },
        }
      )
      if (res.result == 200) {
        this.$message.success(res.message)
        this.getPaymentInfoByCountry()
        if (!this.merchantInfo.id) {
          this.merchantDialog = false
        }
      }
    },
    async getCountryInfo() {
      const {data: resData} = await this.$get(
          `/country/get/${this.params.id}`,
          {
            headers: {
              isLoading: true,
              'Language-Code': this.languageCode
            },
          }
      );
      if (resData.result != 200) return;
      this.params = resData.data
      
      // 处理 mchTypes 数据
      if (this.params.mchTypes) {
        try {
          const mchTypesData = JSON.parse(this.params.mchTypes);
          this.mchTypesTableData = this.mchTypesTableData.map(item => {
            const found = mchTypesData.find(data => data.paymentCode === item.paymentCode);
            return found ? { ...item, mchTypes: found.mchTypes } : item;
          });
        } catch (e) {
          console.error('解析 mchTypes 数据出错:', e);
        }
      }
      
      this.$nextTick(() => {
        this.flag = true;
      });
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          this.params.status = 1
          this.params.isDefault = 0
          
          // 过滤掉不在 commonMchTypes 和 paypalMchTypes 中的选项
          const filteredMchTypes = this.mchTypesTableData.map(item => {
            if (item.paymentCode === 'PP') {
              return {
                ...item,
                mchTypes: item.mchTypes.filter(type => this.paypalMchTypes.includes(type))
              };
            } else {
              return {
                ...item,
                mchTypes: item.mchTypes.filter(type => this.commonMchTypes.includes(type))
              };
            }
          });
          
          // 将过滤后的 mchTypes 转换为 JSON 字符串
          this.params.mchTypes = JSON.stringify(filteredMchTypes);
          
          const {data: resData} = await this.$post("/country/save", this.params, {
            headers: {
              isLoading: true,
              'Language-Code': this.languageCode
            },
          });
          if (resData.result != 200) return;
          this.params.id = resData.data
          this.getCountryList();
          this.getCountryInfo()
          this.$message.success("添加成功!");
        });
      });
    },
    //删除
    async del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$get(
            `/country/remove/${row.id}/`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getCountryList();
        this.$message.success("删除成功!");
      });
    },
    //分页
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getCountryList()
    },
    handleCurrentChange(val) {
      this.pages.pageNo = val;
      this.getCountryList()
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  .fa-line {
    display: block;
    border-right: 1px solid #ccc;
  }

  &Left {
    padding-right: 15px;
    width: auto;

    &_List {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 20px;
    }
  }

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    padding-left: 15px;
    border-left: 1px solid #ccc;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
.payment_box_infos {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  justify-content: space-between;

  .button_item {
    margin-right: 30px;
  }

  .apili_jkds {
    display: flex;
    align-items: center;
    margin-right: 0px;

    span {
      display: block;
      white-space: nowrap;
      margin-left: 60px;
    }
  }
}

.addpay{
  box-sizing: border-box;
  padding: 10px;
  height: 41px;
  width: 100px;
  text-align: center;
  border: 1px solid #E4E7ED;
  margin-top: 5px;
  border-radius: 0 5px 0 0;
  cursor: pointer;
  font-weight: bold;
}
.addPayBtn{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
.footerBtns{
  margin-top: 20px;
}
.sortInput{
  width: 60px;
  height: 20px;
  text-align: center;
  padding: 12px;
}
.tableicon{
  width: 100px;
  height: 20px;
  object-fit: contain;
}

.merchant{
  padding: 20px;
  &__input{
    display: flex;
    justify-content: space-around;
  }
  &__upload{
    width: 75px; 
    height: 75px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }
  .label{
    width: 80px;
  }
  .remark{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    &__input{
      width: 180px;
    }
  }
}
</style>
